export default [
  {
    path: '/activity-anniversary/index',
    name: 'index',
    component: () => import('@/views/activity-anniversary/index'),
    meta: {
      title: '10周年感恩回馈，学习好物疯狂送'
    }
  },
  
]
